"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProject = void 0;
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var lodash_1 = require("lodash");
var compat_1 = require("es-toolkit/compat");
var CalculateQuote_1 = require("./CalculateQuote");
var TaxService_1 = __importDefault(require("../TaxService"));
var calculateProject = function (blocks, taxes, variableService, discountService, billingScheduleOrchestrator, calculateQuoteSettings, disableTotalsCache) {
    var e_1, _a;
    if (disableTotalsCache === void 0) { disableTotalsCache = false; }
    var totals = {};
    try {
        for (var blocks_1 = __values(blocks), blocks_1_1 = blocks_1.next(); !blocks_1_1.done; blocks_1_1 = blocks_1.next()) {
            var block = blocks_1_1.value;
            if (block.type === BlockTypes_1.BlockType.Quote) {
                var currency = block.settings.currency;
                if (totals[currency] == null) {
                    totals[currency] = {
                        postTax: 0,
                        preTax: 0,
                        recurringTotals: {},
                        oneOffTotals: {
                            preTax: 0,
                            postTax: 0,
                        },
                    };
                }
                var calculatedQuote = (0, CalculateQuote_1.calculateQuote)(block, new TaxService_1.default(taxes), variableService, discountService, billingScheduleOrchestrator, calculateQuoteSettings, false, disableTotalsCache);
                totals[currency] = (0, lodash_1.mergeWith)(totals[currency], calculatedQuote, function (destinationValue, sourceValue) {
                    if ((0, compat_1.isObject)(destinationValue) || (0, compat_1.isObject)(sourceValue)) {
                        return undefined;
                    }
                    else {
                        return (destinationValue !== null && destinationValue !== void 0 ? destinationValue : 0) + sourceValue;
                    }
                });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (blocks_1_1 && !blocks_1_1.done && (_a = blocks_1.return)) _a.call(blocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return totals;
};
exports.calculateProject = calculateProject;
